import {get, PathsWithTarget} from '@yandex-delivery/utils'
import {Radio as RadioBase} from '@yandex-delivery/blocks'
import React, {useCallback} from 'react'
import {useController, useFormContext} from 'react-hook-form'

import type {Props} from './Radio.types'

export function Radio<T extends string | undefined>({
  name,
  rules,
  shouldUnregister,
  defaultValue,
  ...otherProps
}: Props<T>): React.ReactElement {
  const {control} = useFormContext()

  const {
    fieldState: {error},
    field: {value, onChange, onBlur},
  } = useController({control, name, rules, shouldUnregister, defaultValue})

  const changeHandler = useCallback(
    (value: unknown) => {
      onChange(value)
      onBlur()
    },
    [onBlur, onChange],
  )

  return (
    <RadioBase
      checked={value === otherProps.value}
      error={get('message', error)}
      name={name}
      onBlur={onBlur}
      onChange={changeHandler}
      value={value}
      {...otherProps}
    />
  )
}

// Хорошо бы иметь какой-то хелпер для вот таких дженерик компонентов, но не уверен что это в общем случае возможно.
// Пока что пишем руками.
/**
 * Например:
 * ```ts
 * type RadioType = 'option1' | 'option2'
 * type OrderForm = {
 *  ...
 *  foo: {bar: RadioType}
 *  ...
 * }
 * // ...
 * <ScopedRadio<OrderForm, RadioType> name="foo.bar" ... />
 * ```
 */
export const ScopedRadio = Radio as <TForm, TValue extends string | undefined>(
  props: Omit<Props<TValue>, 'name'> & {name: PathsWithTarget<TForm, TValue>},
) => React.ReactElement
